/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InputField } from 'cx-ui-components';
import { SelectInputField } from './SelectInputField';

const ProficiencyFieldWrapper = styled.div`
  display: flex;
  margin-left: 210px;
  margin-top: -5px;
`;

export class ProficiencyField extends React.Component {
  componentDidMount() {
    const { index, entity, allOrAny, change } = this.props;
    change(`basicQuery[${[index]}].selectedFilters.${entity}.${allOrAny}.proficiencyType`, '>=');
    change(`basicQuery[${[index]}].selectedFilters.${entity}.${allOrAny}.proficiencyCount`, '1');
  }
  render() {
    const { index, entity, allOrAny } = this.props;
    return (
      <ProficiencyFieldWrapper>
        <SelectInputField
          name={`basicQuery[${[index]}][selectedFilters]${entity}.${allOrAny}[proficiencyType]`}
          data-automation="skillsProficiencyDropdownList"
          options={[
            { label: 'Proficiency at Least', value: '>=' },
            { label: 'Proficiency at Most', value: '<=' },
            { label: 'Proficiency Exactly', value: '=' },
          ]}
          required
        />
        <InputField
          name={`basicQuery[${[index]}][selectedFilters]${entity}.${allOrAny}[proficiencyCount]`}
          componentType="input"
          dataType="number"
          minValue="1"
          disabled={false}
          hideLabel
          label=""
          integersOnlyAllowed
          data-automation="skillsProficiencyInput"
        />
      </ProficiencyFieldWrapper>
    );
  }
}

ProficiencyField.propTypes = {
  index: PropTypes.number,
  entity: PropTypes.string,
  allOrAny: PropTypes.string,
  change: PropTypes.func,
};
